import { useEffect } from 'react'

import { useGrowthBook } from '@growthbook/growthbook-react'

import {
  getIsNewUserForSpotifyMinBudget,
  getUserId,
} from 'src/Redux/auth-process/userSlice/selectors'
import {
  getHasPaidCampaign,
  usePaidCampaignsCountQuery,
} from 'src/Redux/metadataApi'
import {
  useUpdateArtistFeatureFlagsMutation,
  useGetArtistFeatureFlagsQuery,
} from 'src/Redux/A-BFeaturesApi'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { useAppSelector } from 'src/Hooks/redux'

const SPOTIFY_MIN_BUDGET_FEATURE_NAME = 'spotify_campaign_min_budget_group'
const SPOTIFY_MIN_BUDGET_BE_FEATURE_NAME = 'spotify_campaign_min_budget_group'

export const useSpotifyCampaignMinBudgetExperiment = (): null => {
  const growthbook = useGrowthBook()
  const isGrowthBookReady = growthbook.ready
  const growthbookAttributes = growthbook.getAttributes()?.id
  const userId = useAppSelector(getUserId)
  const { data: paidCampaignsCountData } = usePaidCampaignsCountQuery(
    CampaignPlatformTypeEnum.SPOTIFY,
  )
  const hasPaidCampaign = getHasPaidCampaign(paidCampaignsCountData)

  const [addFeatureForUser] = useUpdateArtistFeatureFlagsMutation()

  const isNewUser = useAppSelector(getIsNewUserForSpotifyMinBudget)

  const { data: featureValue, isSuccess: featuresIsSucceeded } =
    useGetArtistFeatureFlagsQuery(void 0, {
      selectFromResult: (result) => ({
        ...result,
        data: result?.data?.features?.find(
          (item) => item?.name === SPOTIFY_MIN_BUDGET_BE_FEATURE_NAME,
        )?.variation,
      }),
    })

  useEffect(() => {
    const isValidUser = isNewUser && !hasPaidCampaign

    const isFeatureNeeded =
      featuresIsSucceeded && !featureValue && isValidUser && isGrowthBookReady

    const isAttributesSet = growthbookAttributes === userId

    if (isFeatureNeeded && isAttributesSet) {
      const variant = growthbook.getFeatureValue(
        SPOTIFY_MIN_BUDGET_FEATURE_NAME,
        0,
      )

      addFeatureForUser({
        featureName: SPOTIFY_MIN_BUDGET_BE_FEATURE_NAME,
        variation: Number(variant),
      })
    }
  }, [
    addFeatureForUser,
    featureValue,
    featuresIsSucceeded,
    growthbook,
    isGrowthBookReady,
    hasPaidCampaign,
    isNewUser,
    growthbookAttributes,
    userId,
  ])

  return null
}
